import { FormRadioGroup, type FormRadioGroupProps } from "@prismicio/editor-ui"
import {
  type Control,
  type FieldValues,
  type Path,
  useController,
} from "react-hook-form"

interface HookFormRadioGroupProps<T extends FieldValues, V extends string>
  extends Omit<FormRadioGroupProps<V>, "value" | "onChange"> {
  control: Control<T>
  name: Path<T>
}

export function HookFormRadioGroup<T extends FieldValues, V extends string>(
  props: HookFormRadioGroupProps<T, V>,
) {
  const { control, name, ...restProps } = props

  const { field, fieldState } = useController({
    control,
    name,
  })

  return (
    <FormRadioGroup
      {...restProps}
      name={name}
      value={getValue(field.value)}
      onChange={field.onChange}
      error={fieldState.error?.message}
    />
  )
}

function getValue(value: undefined | null | string | number): string {
  if (value === undefined || value === null) return ""

  if (typeof value === "number") {
    if (isNaN(value)) return ""
    return value.toString()
  }

  return value
}
